<template>
  <div class="card card-custom py-0">
    <div class="py-0 pb-2">
      <div class="col-12 mb-5" style="background-color: #f3f6f9; border:1px solid #0b5a85; border-radius: 12px;">
        <div class="d-flex flex-column items-center justify-content-center w-100">
          <div class="d-block align-content-center">
            <p class="text-center mb-0">
            <span v-html="getIconByKey('icons.menu.order', {
                        class: 'w-75px h-75px object-cover'
                  })">
            </span>
            </p>
          </div>
          <h4 class="text-center w-100 text-primary font-weight-boldest"
              style="text-align: center; margin-top: -10px;">
            {{ $t("general.instructions") }}
          </h4>
          <br>
        </div>

        <div class="mx-0 mb-1" style="height: auto; overflow-x:auto">
          <table class="table-responsive w-100 mb-0">
            <thead class="">
            <tr class="table-tr">
              <th class="tlmt-items-1">
                <div class="d-flex justify-content-center items-center text-sm">
                  {{ $t('general.id') }}
                </div>
              </th>
              <th class="tlmt-items">
                <div class="d-flex justify-content-center items-center text-sm">
                  Tedarikçi Firma
                </div>
              </th>
              <th class="tlmt-items">
                <div class="d-flex justify-content-center items-center text-sm">
                  Kumaş
                </div>
              </th>
              <th class="tlmt-items">
                <div class="d-flex justify-content-center items-center text-sm">
                  Renk
                </div>
              </th>
              <th class="tlmt-items">
                <div class="d-flex justify-content-center items-center text-sm">
                  Talimat Türü
                </div>
              </th>
              <th class="tlmt-items">
                <div class="d-flex justify-content-center items-center text-sm">
                  {{ $t('general.amount') }}
                </div>
              </th>
              <th class="tlmt-items">
                <div class="d-flex justify-content-center items-center text-sm">
                  Kalan Miktar
                </div>
              </th>
              <th class="tlmt-items">
                <div class="d-flex justify-content-center items-center text-sm">
                  Link
                </div>
              </th>
            </tr>
            </thead>
            <tbody class="">
            <tr v-for="(item, index) in formattedInstructions" :key="index" class="table-tr">
              <td class="tlmt-items-1 text-sm d-flex justify-content-center align-items-center">
                {{ ++index}}
              </td>
              <td class="tlmt-items text-sm">
               {{ item.supplier_company.name}}
              </td>
              <td class="tlmt-items text-sm">
               {{ item.order_fabric ? item.order_fabric.type : '-' }}
              </td>
              <td class="tlmt-items text-sm">
                {{ item.order_size_and_color ? item.order_size_and_color.color_name : '-' }}
              </td>
              <td class="tlmt-items text-sm">
               {{ getInstructionType(item.tmp_type)}}
              </td>
              <td class="tlmt-items text-sm">
                {{ Number(item.total_amount) | amountFormat  }} {{ getUnitNameByOrderFabric(item) || 'KG' }}
              </td>
              <td class="tlmt-items text-sm">
                {{ (Number(item.total_amount) - Number(item.incoming_amount)) | amountFormat }} {{ getUnitNameByOrderFabric(item) || 'KG' }}
              </td>
              <td class="tlmt-items text-sm">
                <div class="d-flex flex-column justify-content-between align-items-center">
                  <a class="link-btn text-center" :href="item.pdf_link" target="_blank">İndir</a>

                  <a class="link-btn text-center" :href="item.order_pdf_link" target="_blank" v-if="item.order_pdf_link">Firma Bazlı İndir</a>

                  <a class="link-btn text-center" :href="item.model_pdf_link" target="_blank" v-if="item.model_pdf_link">Firma Bazlı İndir</a>

                  <a class="link-btn text-center" :href="item.accessory_pdf_link" target="_blank" v-if="item.accessory_pdf_link">Firma Bazlı İndir</a>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-12 mb-5" style="background-color: #f3f6f9; border:1px solid #0b5a85; border-radius: 12px;" v-if="formattedAccessories && formattedAccessories.length">
        <div class="d-flex flex-column items-center justify-content-center w-100">
          <div class="d-block align-content-center">
            <p class="text-center mb-0">
            <span v-html="getIconByKey('icons.menu.order', {
                        class: 'w-75px h-75px object-cover'
                  })">
            </span>
            </p>
          </div>
          <h4 class="text-center w-100 text-primary font-weight-boldest"
              style="text-align: center; margin-top: -10px;">
            {{ $t("general.expenses") }}
          </h4>
          <br>
        </div>

        <div class="mx-0 mb-1" style="height: auto; overflow-x:auto">
          <table class="table-responsive w-100 mb-0">
            <thead class="table-tr">
            <tr>
              <th class="tlmt-items-1">
                <div class="d-flex justify-content-center items-center text-sm">
                  {{ $t('general.id') }}
                </div>
              </th>
              <th class="tlmt-items">
                <div class="d-flex justify-content-center items-center text-sm">
                  {{$t('general.supplier_company_name')}}
                </div>
              </th>
              <th class="tlmt-items">
                <div class="d-flex justify-content-center items-center text-sm">
                  {{$t('general.fabric')}}
                </div>
              </th>
              <th class="tlmt-items">
                <div class="d-flex justify-content-center items-center text-sm">
                  {{$t('sample.color')}}
                </div>
              </th>

              <th class="tlmt-items">
                <div class="d-flex justify-content-center items-center text-sm">
                  {{$t('general.instruction_type ')}}
                </div>
              </th>
              <th class="tlmt-items">
                <div class="d-flex justify-content-center items-center text-sm">
                  {{ $t('general.amount') }}
                </div>
              </th>
              <th class="tlmt-items">
                <div class="d-flex justify-content-center items-center text-sm">
                  {{ $t('general.remaining_amount ') }}
                </div>
              </th>
              <th class=" navy-blue-border-bottom-1px">
                <div class="d-flex justify-content-center items-center text-sm">
                  Link
                </div>
              </th>
            </tr>
            </thead>
            <tbody class="">
            <tr v-for="(item, index) in formattedInstructions">
              <td class="navy-blue-border-right-1px items-start">
                {{ ++index}}
              </td>
              <td class="navy-blue-border-right-1px">
               {{ item.supplier_company.name}}
              </td>
              <td class="navy-blue-border-right-1px">
               {{ item.order_fabric ? item.order_fabric.type : '-' }}
              </td>
              <td class="navy-blue-border-right-1px">
                {{ item.order_size_and_color ? item.order_size_and_color.color_name : '-' }}
              </td>
              <td class="navy-blue-border-right-1px">
               {{ getInstructionType(item.tmp_type)}}
              </td>
              <td class="navy-blue-border-right-1px">
                {{ Number(item.total_amount) | amountFormat  }} {{ getUnitNameByOrderFabric(item) || 'KG' }}
              </td>
              <td class="navy-blue-border-right-1px">
                {{ (Number(item.total_amount) - Number(item.incoming_amount)) | amountFormat }} {{ getUnitNameByOrderFabric(item) || 'KG' }}
              </td>
              <td class="">
                <div class="d-flex justify-content-start">
                  <a class="btn btn-sm btn-success rounded-full mx-1" :href="item.pdf_link" target="_blank">İndir</a>

                  <a class="btn btn-sm btn-success rounded-full mx-1" :href="item.order_pdf_link" target="_blank" v-if="item.order_pdf_link">Firma Bazlı İndir</a>

                  <a class="btn btn-sm btn-success rounded-full mx-1" :href="item.model_pdf_link" target="_blank" v-if="item.model_pdf_link">Firma Bazlı İndir</a>

                  <a class="btn btn-sm btn-success rounded-full mx-1" :href="item.accessory_pdf_link" target="_blank" v-if="item.accessory_pdf_link">Firma Bazlı İndir</a>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-12 mb-5" style="background-color: #f3f6f9; border:1px solid #0b5a85; border-radius: 12px;" v-if="formattedExpenses && formattedExpenses.length">
        <div class="d-flex flex-column items-center justify-content-center w-100">
          <div class="d-block align-content-center">
            <p class="text-center mb-0">
            <span v-html="getIconByKey('icons.menu.order', {
                        class: 'w-75px h-75px object-cover'
                  })">
            </span>
            </p>
          </div>
          <h4 class="text-center w-100 text-primary font-weight-boldest"
              style="text-align: center; margin-top: -10px;">
            {{ $t("general.expenses") }}
          </h4>
          <br>
        </div>

        <div class="mx-0 mb-1" style="height: auto; overflow-x:auto">
          <table class="table-responsive w-100 mb-0">
            <thead class="table-tr">
            <tr>
              <th class="tlmt-items-1">
                <div class="d-flex justify-content-center items-center text-sm">
                  {{ $t('general.id') }}
                </div>
              </th>
              <th class="tlmt-items">
                <div class="d-flex justify-content-center items-center text-sm">
                  Tedarikçi Firma
                </div>
              </th>
              <th class="tlmt-items">
                <div class="d-flex justify-content-center items-center text-sm">
                  Masraf Türü
                </div>
              </th>
              <th class="tlmt-items">
                <div class="d-flex justify-content-center items-center text-sm">
                  Renk
                </div>
              </th>
              <th class="tlmt-items">
                <div class="d-flex justify-content-center items-center text-sm">
                  {{ $t('general.amount') }}
                </div>
              </th>
              <th class="tlmt-items">
                <div class="d-flex justify-content-center items-center text-sm">
                  Kalan Miktar
                </div>
              </th>
              <th class="tlmt-items">
                <div class="d-flex justify-content-center items-center text-sm">
                  Link
                </div>
              </th>
            </tr>
            </thead>
            <tbody class="navy-blue-bottom-1px">
            <template v-for="(expenseItem, expenseIndex) in formattedExpenses">
              <tr v-for="(item, index) in expenseItem.order_expense_details" :key="index">
                <td class="tlmt-items-1 text-sm d-flex justify-content-center align-items-center">
                  {{ expenseIndex++ +  ++index}}
                </td>
                <td class="tlmt-items text-sm">
                  {{ item.supplier_company.name}}
                </td>
                <td class="tlmt-items text-sm">
                  {{expenseItem.expense.translations[0].name}}
                </td>

                <td class="tlmt-items text-sm">
                  {{item.order_size_and_color ? item.order_size_and_color.color_name : '-' }}
                </td>
                <td class="tlmt-items text-sm">
                  {{ Number(item.total_amount) | amountFormat }} {{ getUnitName(expenseItem.unit_id) || '' }}
                </td>
                <td class="tlmt-items text-sm">
                  {{ Number(item.remaining_amount)  | amountFormat }} {{ getUnitName(expenseItem.unit_id) || '' }}
                </td>
                <td class="tlmt-items text-sm">
                  <div class="d-flex flex-column justify-content-between align-items-center">
                    <a class="link-btn text-center" :href="item.order_pdf_link" target="_blank" v-if="item.order_pdf_link">İndir</a>

                    <a class="link-btn text-center" :href="item.model_pdf_link" target="_blank" v-if="item.model_pdf_link">Firma Bazlı İndir</a>
                  </div>
                </td>
              </tr>
            </template>

            </tbody>
          </table>
        </div>
      </div>
      <div class="d-flex justify-content-center mt-3">
        <button
            type="button"
            @click="$emit('onCloseModal')"
            class="btn btn-outline-primary font-weight-bold cursor-pointer ml-4 text-uppercase rounded-full ">
          <span class="font-weight-boldest" style="font-weight: bolder;">{{ $t('general.close') }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "instructionsModal",
  props: {
    items: {
      required: true,
      type: Array,
    },
    expenses: {
      required: false,
    },
    instructionTypes: {
      required: true,
      type: Array,
    },
    units: {
      required: true,
      type: Array,
    }
  },
  data() {
    return {
      //instructionTypesArray: [],
    }
  },
  computed: {
    formattedInstructions() {
      let instructions = [];
      if (this.items) {
        this.items.forEach(item => {
          if (item.hasOwnProperty('incoming')) {
            item.incoming_amount = item.incoming;
          }

          if (item.hasOwnProperty('fabric_request_id') || item.hasOwnProperty('order_id')) {

            if (item.hasOwnProperty('fabric_request_id')) {

              item.order_fabric = {
                type: item.fabric_request.sample_product_informations.fabric_type.translations[0].name
              }
              item.order_size_and_color = {
                color_name: item.fabric_request.sample_product_informations.color
              }
            }
            instructions.push(item);
          }
        })
      }
      return instructions;
    },

    formattedAccessories() {
      let instructions = [];

      if (this.items) {
        this.items.forEach(item => {
          if (item.hasOwnProperty('accessory_request_id')) {
            instructions.push(item);
          }
        })
      }
      return instructions;

    },
    formattedExpenses() {
      let instructions = [];

      if (this.expenses) {
        this.expenses.forEach(item => {
          instructions.push(item);
        })
      }
      return instructions;
    },
    modelProxy: {
      get() {
        return this.model;
      },
      set(value) {
        this.$emit('update:model', value);
      }
    }
  },
  methods: {
    getInstructionType(id) {
      if (id) {
        return this.instructionTypes.find(item => +item.id === +id).translations[0].name;
      }
    },
    getUnitName(id) {
      if (id) {
        return this.units.find(item => +item.id === +id).code;
      }
    },
    getUnitNameByOrderFabric(item) {
      if (item && item.hasOwnProperty('amount_unit_id')) {
        return this.units.find(unitItem => +unitItem.id === +item.amount_unit_id) ? this.units.find(unitItem => +unitItem.id === +item.amount_unit_id).code : null;
       } else if (item) {
        let orderFabricUnitId = item.order_fabric ? item.order_fabric.unit_id : null;
        return orderFabricUnitId ? this.units.find(item => +item.id === +orderFabricUnitId).code : null;
      }
    },
    log(){
      console.log(this.items);
    }
  }
}
</script>


<style lang="scss" scoped>
@import '@/assets/sass/components/_variables.demo.scss';

.radio.radio-primary > input:checked ~ span::after {
  background-color: $primary;
}
.user-image {
  border-radius: 50%;
}

.tlmt-items {
  border-right: 1px solid #78cdea;
  border-bottom: 1px solid #78cdea;
  border-top: 1px solid #78cdea;
  min-width: 100px !important;
  padding: 4px 8px !important;
}

.tlmt-items-1 {
  border-right: 1px solid #78cdea;
  border-bottom: 1px solid #78cdea;
  border-top: 1px solid #78cdea;
  max-width: 20px !important;
  padding: 4px 8px !important;
  font-size: 8px;
}

.link-btn {
  padding:  2px 2px;
  border-radius: 12px;
  background-color: #0b5a85;
  color: #fff;
  width: 80px;
  font-size: 8px;
  margin-bottom: 2px;
  display:flex;
  align-items: center;
  justify-content:center;
}

</style>
